module.exports = __webpack_public_path__ + "static/media/reconnecting.549c6fa9.svg";